import { type Interval } from 'date-fns';

import { type AkaVeranstaltungId } from '../../../../../dtos.js';

export type IntervalWithOptionalVeranstaltung = {
  veranstaltung?: { akaVeranstaltungId: AkaVeranstaltungId; [key: string]: unknown } | null;
  zeitraeume: Interval<Date, Date>[];
};

export const eventCreationStrategies = {
  /**
   * IF: The resource is currently not selected by the Veranstaltung
   * > Create separate events for each available AblaufTag
   *
   * ELSE:
   * Create a single event for the clicked date and merge it with adjacent events
   */
  SEPARATE_EVENTS_FOR_ALL_ABLAUFTAGE: 'separateEventsForAllAblauftage',

  /**
   * Create a single event that spans all AblaufTage
   */
  SINGLE_EVENT_SPANNING_ALL_ABLAUFTAGE: 'singleEventSpanningAllAblauftage',
} as const;

export type EventCreationStrategy = (typeof eventCreationStrategies)[keyof typeof eventCreationStrategies];
